import {
    dropdownFieldConfigConstructor,
    rangeFieldConfigConstructor,
    switchWithSelectFieldConstructor,
} from "../../../filter-configs/fieldContructors";
import { Category } from "../../../filter-configs/categories";
import { switchWithSelectAndTagsFieldConstructor } from "../../../filter-configs/fieldContructors/switchWithSelectAndTags";

const CHRSScoreType = ["low", "intermediate", "high"].map((value) => ({
    value,
    label: value ? `my-risk.score-label.${value}` : "",
}));

export const riskScoreFields = {
    ...dropdownFieldConfigConstructor({
        category: Category.RISK_SCORE,
        pathToValue: "risk.hematology_score_type",
        dropdownValues: CHRSScoreType,
        label: "Clonal Hematopoiesis Risk Score (CHRS)",
    }),
    ...rangeFieldConfigConstructor({
        category: Category.RISK_SCORE,
        pathToValue: "risk.full_risk_percent",
        label: "my-risk.cardiovascular-risk-percent",
        fieldWidth: 56,
    }),
    ...switchWithSelectFieldConstructor({
        pathToSwitchQuestion: "anamnesis.hasCCS",
        pathToSelectValue: "anamnesis.ccsValue",
        label: "anamnesis.clinical.CCSValueLabelInQuery",
        selectOptions: ["CCS2", "CCS3", "CCS4"],
        category: Category.RISK_SCORE,
    }),
    ...switchWithSelectAndTagsFieldConstructor({
        category: Category.RISK_SCORE,
        pathToValue: "anamnesis.NYHA",
        pathToSwitchQuestion: "anamnesis.hasNYHA",
        pathToSelectValue: "anamnesis.nyhaValue",
        label: "anamnesis.clinical.NYHAValueLabelInQuery",
        selectOptions: ["NYHA2", "NYHA3", "NYHA4"],
        tagsValues: [
            { value: "rattlingNoises", label: "anamnesis.clinical.rattlingNoisesButton" },
            { value: "neckVeinCongestion", label: "anamnesis.clinical.neckVeinCongestionButton" },
            { value: "periphereOdeme", label: "anamnesis.clinical.periphereOdemeButton" },
            { value: "ruhedyspnose", label: "anamnesis.clinical.ruhedyspnoseButton" },
        ],
    }),
};
